import Auth from '@aws-amplify/auth'
import { constants } from '../constants'
import { jwtDecode } from 'jwt-decode'
import { Config } from 'config'
import { fetchCognitoRegionConfig } from '../api/showingChoiceServicesRequests'

export async function getUserInfo() {
  const currentSession = await Auth.currentSession()
  const token = currentSession.getIdToken().payload

  return token || null
}

export const nonSupportedPagesList: Array<string> = [
  '/dashboard',
  '/appeal-fine',
  '/report-a-violation',
  'Start a Brokerage',
  'RE Technology',
  '/manage/officenews',
  '/manage/associationnews',
  'Add Bright MLS News',
  '/contact-us',
  '/request-visit',
  '/bright-feedback',
  'http://www.rateplug.com/rateplug.asp?name=BRIGHTMLS',
  'http://setup-sso.showingtime.com',
  'http://www.getsmartcharts.com/statistics',
]

export const getCurrentUrl = () => {
  const redirectUrl = localStorage.getItem(constants.REDIRECT_URL)
  const path = redirectUrl ? redirectUrl : window.location.pathname
  const pathVal = path.includes('manage/associationnews')
    ? '/manage/associationnews'
    : `${path}`
  return pathVal
}

export function getCookieValueByName(name: string) {
  const cookieName = name + '='
  const cookieArray = document.cookie.split(';')

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length)
    }
  }
  return ''
}

export function setCookie(cName: string, value: string, exdays: number | null) {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + (exdays ? exdays : 0))

  const cookieDomain = '.' + document.domain.split('.').splice(1).join('.')

  const cValue =
    escape(value) +
    (exdays == null ? '' : '; expires=' + exdate.toUTCString()) +
    ';domain=' +
    cookieDomain +
    ';path=/'
  document.cookie = cName + '=' + cValue
}

export function getCookieVal(name: string) {
  const value: any = '; ' + document.cookie
  const parts = value.split('; ' + name + '=')
  if (parts.length === 2) return parts.pop().split(';').shift()
}

export async function getJWTToken() {
  try {
    // Amplify owns token refresh. Keep the menu widget's copy in sync, but
    // never use that copy as the source for ShowingChoice API requests.
    const session = await Auth.currentSession()
    const token = session.getIdToken().getJwtToken()
    localStorage.setItem(constants.TOKEN_FIELD, token)
    return token
  } catch (error) {
    localStorage.removeItem(constants.TOKEN_FIELD)
    // Silent fail - no valid session
  }

  return null
}

export async function getTokenDetails() {
  const token = await getJWTToken()
  if (token) {
    return jwtDecode(token)
  }
  return null
}

export function deleteLocalStorageExcept(itemKey: string) {
  const itemvalue: any = localStorage.getItem(itemKey)
  localStorage.clear()
  localStorage.setItem(itemKey, itemvalue)
}

export function clearCookie() {
  const cookieValues = document.cookie.split(';')
  for (const value of cookieValues) {
    if (
      value.trim().indexOf('brightmlssubscriber') >= 0 ||
      value.trim().indexOf('_brightmlspermissions') >= 0
    ) {
      setCookie(value.trim().split('=')[0], '', 0)
    }
  }
  setCookie('brightmlsmenutoken', '', 0)
  setCookie('matrixuserid', '', 0)
  setCookie('loggedinsubscriber', '', 0)
  setCookie('brightmlsAWSLoggedIn', '', 0)
}

export function clearNonAwsCookies() {
  setCookie('brightmlsmenutoken', '', 0)
  setCookie('matrixuserid', '', 0)
  setCookie('loggedinsubscriber', '', 0)
  setCookie('brightmlsAWSLoggedIn', '', 0)
  setCookie('brightmlssubscriber', '', 0)
}

export async function initializePendo() {
  const userData: any = await getTokenDetails()
  if (!userData) {
    return
  }

  const { pendo } = window as any
  const config = {
    visitor: {
      id: userData['custom:MemberMlsId'],
      name:
        userData.MemberPreferredFirstName +
        ' ' +
        userData.MemberPreferredLastName,
      email: userData.email,
      role: userData.MemberSubType,
      association: userData.MemberAssociationPrimary,
      county: userData.OfficeCounty,
    },
    account: {
      id: userData.OfficeMlsId,
      name: userData.BrokerOfficeName,
    },
  }

  pendo.initialize(config)
}

export const switchRegionCognitoConfig = async (
  config: Config,
  setConfig: (config: Config) => void,
) => {
  const newConfig: Config = { ...config }
  const regionCognito = await fetchCognitoRegionConfig(config)

  newConfig.amplifyConfig = regionCognito.amplifyConfig
  setConfig(newConfig)
}
